import { NavLink, Outlet } from 'react-router-dom';

import css from './Tnas.module.css';

function Tnas() {
    return (
        <div className={css.main}>
            <div className={css.menu}>
                <nav className={css.nav}>
                    <NavLink to="/tna/overview">Overview</NavLink>
                    <NavLink to="/tna/modules">Modules</NavLink>
                    {/* <NavLink to="/tna/differences">Differences</NavLink> */}
                </nav>
                {/* <nav className={css.nav}>
                    <NavLink to="/course/details">Details</NavLink>
                </nav> */}
            </div>
            <Outlet />
        </div>
    );
}

export default Tnas;